import { Spinner } from "@chakra-ui/react";
import { TableListButtonDisabled } from "../../../atoms/Button/TableListButtonDisabled";

export function SpinnigButton() {
  return <TableListButtonDisabled color="white" bg="#999999" icon={Spinner} />;
}
